import { motion } from "framer-motion";
import { Recycle, Leaf, Repeat } from "lucide-react";

const pillars = [
  { icon: Recycle, title: "Sorted, Not Dumped", desc: "Every load is hand-sorted to pull recyclables before anything reaches the curb." },
  { icon: Repeat, title: "Resale Partners", desc: "We work with local resellers to give your old belongings a second life whenever possible." },
  { icon: Leaf, title: "Edmonton First", desc: "Committed to keeping our city's landfills lighter and our community greener." },
];

export const EcoCommitment = () => (
  <section className="bg-background py-12 md:py-16">
    <div className="container">
      <div className="mb-12 text-center">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.3em] text-gold">Eco-Commitment</p>
        <h2 className="font-display text-5xl tracking-wide text-ink md:text-6xl">Responsible Disposal & Resale</h2>
        <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
          We don't just hit the landfill. Garage Kings YEG is committed to Edmonton's environment —
          sorting every load for recycling and partnering with local resellers to extend the life of your stuff.
        </p>
      </div>
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-3">
        {pillars.map((p, i) => (
          <motion.div
            key={p.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="rounded-2xl border-2 border-border bg-card p-6 text-center transition-all hover:border-gold hover:-translate-y-1 hover:shadow-gold sm:p-8"
          >
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-ink text-gold">
              <p.icon className="h-7 w-7" />
            </div>
            <h3 className="mt-4 font-display text-2xl tracking-wide text-ink">{p.title}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
